/**
 * Shared utilities for Amazon Connect integration.
 */

export interface ContactAttribute {
  value?: string;
}

/**
 * Extract the actual string value from a Connect contact attribute.
 * Handles both raw strings and { value: string } objects.
 */
export function getAttrValue(
  attr: ContactAttribute | string | undefined,
): string | undefined {
  if (!attr) return undefined;
  if (typeof attr === "object" && attr !== null && "value" in attr) {
    return attr.value;
  }
  return typeof attr === "string" ? attr : undefined;
}

/**
 * Extract the Connect instance ARN from an agent ARN.
 *
 * Agent ARN format: arn:aws:connect:region:account:instance/{iid}/agent/{aid}
 * Instance ARN format: arn:aws:connect:region:account:instance/{iid}
 */
export function getInstanceArn(agentArn: string): string {
  const agentIndex = agentArn.indexOf("/agent/");
  if (agentIndex === -1) return agentArn;
  return agentArn.substring(0, agentIndex);
}
